import React from 'react';
import { CustomSignIn } from '../CustomSignIn';
import { CircularProgress, Typography, Box } from '@mui/material';

// Extract function to prevent recreation on every render
const handleAuthStateChange = (state, data) => {
  // Handle state changes for unified login
  if (state === 'signedIn') {
    window.location.reload();
  }
};

/**
 * Authentication Gate Component
 * Handles OAuth2 authentication rendering logic
 */
export const AuthenticationGate = ({
  authState,
  form_oauth2,
  updateUsername,
}) => {
  // Show loading state while checking authentication
  if (authState === 'loading') {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="50vh"
        padding={3}
      >
        <CircularProgress size={40} color="primary" />
        <Typography variant="body1" style={{ marginTop: 16, color: '#666' }}>
          Checking authentication status...
        </Typography>
      </Box>
    );
  }

  if (
    authState !== 'signedIn' &&
    form_oauth2 !== undefined &&
    form_oauth2 !== 'undefined' &&
    form_oauth2 !== '' &&
    form_oauth2 !== null
  ) {
    return (
      <CustomSignIn
        authState={authState}
        updateUsername={updateUsername}
        onStateChange={handleAuthStateChange}
      />
    );
  }
  return null;
};

export default AuthenticationGate;
